import { PRIVACY_ADS_CONSENT_NAME, HS_DATA_PRIVACY_ADS_CONSENT_FIELD } from 'FormsUI/constants/AdConsent';
import contactObjectTypeId from 'ui-forms-components/constants/objectTypeIds/contactObjectTypeId';
export const addAdConsentFlattenedProperty = flattenedObjects => {
  if (flattenedObjects[contactObjectTypeId] && !flattenedObjects[contactObjectTypeId][PRIVACY_ADS_CONSENT_NAME]) {
    flattenedObjects[contactObjectTypeId][PRIVACY_ADS_CONSENT_NAME] = HS_DATA_PRIVACY_ADS_CONSENT_FIELD;
  }
  return flattenedObjects;
};